import {
    GetStudentDetailsActionsTypes,
    GetStudentGradesActionsTypes,
    GetStudentAssignmentsActionsTypes,
    GetStudentAttendanceActionsTypes,
    UpdateStudentDetailsActionsTypes,
    GetStudentAnalyticsActionsTypes,
    IStudentPageState,
    StudentPageActions,
} from './types';

const initialState: IStudentPageState = {
    student: null,
    grades: [],
    assignments: [],
    attendance: [],
    analytics: null,
    loading: false,
    error: '',
    success: false,
    grades_loading: false,
    assignments_loading: false,
    attendance_loading: false,
    analytics_loading: false,
};

const studentPageReducer = (state: IStudentPageState = initialState, action: StudentPageActions) => {
    switch (action.type) {
        
        // ----------------------Get Student Details Actions-----------------------
        case GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS: {
            return {
                ...state,
                loading: true,
                error: '',
                success: false
            };
        }
        case GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                student: data,
                loading,
                success: true,
                error: ''
            };
        }
        case GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                loading,
                success: false,
                error: error,
                student: null
            };
        }
        
        // ----------------------Get Student Grades Actions-----------------------
        case GetStudentGradesActionsTypes.GET_STUDENT_GRADES: {
            return {
                ...state,
                grades_loading: true
            };
        }
        case GetStudentGradesActionsTypes.GET_STUDENT_GRADES_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                grades: data,
                grades_loading: loading
            };
        }
        case GetStudentGradesActionsTypes.GET_STUDENT_GRADES_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                grades_loading: loading,
                error: error
            };
        }

        // ----------------------Get Student Assignments Actions-----------------------
        case GetStudentAssignmentsActionsTypes.GET_STUDENT_ASSIGNMENTS: {
            return {
                ...state,
                assignments_loading: true
            };
        }
        case GetStudentAssignmentsActionsTypes.GET_STUDENT_ASSIGNMENTS_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                assignments: data,
                assignments_loading: loading
            };
        }
        case GetStudentAssignmentsActionsTypes.GET_STUDENT_ASSIGNMENTS_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                assignments_loading: loading,
                error: error
            };
        }

        // ----------------------Get Student Attendance Actions-----------------------
        case GetStudentAttendanceActionsTypes.GET_STUDENT_ATTENDANCE: {
            return {
                ...state,
                attendance_loading: true
            };
        }
        case GetStudentAttendanceActionsTypes.GET_STUDENT_ATTENDANCE_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                attendance: data,
                attendance_loading: loading
            };
        }
        case GetStudentAttendanceActionsTypes.GET_STUDENT_ATTENDANCE_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                attendance_loading: loading,
                error: error
            };
        }

        // ----------------------Update Student Details Actions-----------------------
        case UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS: {
            return {
                ...state,
                loading: true
            };
        }
        case UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                student: data,
                loading,
                success: true
            };
        }
        case UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                loading,
                success: false,
                error: error
            };
        }

        // ----------------------Get Student Analytics Actions-----------------------
        case GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS: {
            return {
                ...state,
                analytics_loading: true
            };
        }
        case GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS_SUCCESS: {
            const { loading, data } = action;
            return {
                ...state,
                analytics: data,
                // Also populate grades and assignments from analytics for backwards compatibility
                grades: data.grades || [],
                assignments: data.tests || [],
                analytics_loading: loading
            };
        }
        case GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS_ERROR: {
            const { error, loading } = action;
            return {
                ...state,
                analytics_loading: loading,
                error: error
            };
        }

        default:
            return state;
    }
};

export default studentPageReducer;
